import { errorsDrawerOpenAtom } from "@features/builder/ErrorsDrawer/errorsDrawerOpenAtom"
import { nodesValidationAtom } from "@features/builder/graph/nodes/validation/validationAtom"
import { AppNode, EdgeData } from "@features/builder/graph/types"
import {
  raiseEmptyGraphError,
  raiseGraphValidationErrors,
} from "@features/builder/graph/validation/errors"
import { Edge, ReactFlowInstance } from "@xyflow/react"
import { getDefaultStore } from "jotai"

export const validateGraph = (
  reactFlowInstance: ReactFlowInstance<AppNode, Edge<EdgeData>>,
): boolean => {
  const nodesValidation = getDefaultStore().get(nodesValidationAtom)
  const hasNodeValidationErrors = Object.values(nodesValidation).some((nodeValidation) =>
    Object.values(nodeValidation).some(({ status }) => status === "error"),
  )

  const nodes = reactFlowInstance.getNodes()

  if (nodes.length === 0) {
    raiseEmptyGraphError()
    return false
  }

  const hasEdgesWithError = reactFlowInstance.getEdges().some((x) => x.label)
  if (hasNodeValidationErrors || hasEdgesWithError) {
    getDefaultStore().set(errorsDrawerOpenAtom, true)
    raiseGraphValidationErrors()
    return false
  }

  return true
}
